import { format, isValid, parseISO } from 'date-fns'
import moment from 'moment'
import 'moment/locale/pt-br'

export const noMask = (value) => value.replace(/\D/g, '')

export const dateMask = (value) => {
  return value
    ?.replace(/\D/g, '')
    .replace(/(\d{2})(\d)/, '$1/$2')
    .replace(/(\d{2})(\d)/, '$1/$2')
    .replace(/(\d{2}\/\d{2}\/\d{4})\d+?$/, '$1')
}

export const dateString = (value) => {
  const date = value?.split('/') || undefined
  if (date?.length !== 3) return undefined
  if (date[2].length !== 4) return undefined
  return `${date[0]}%2F${date[1]}%2F${date[2]}`
}

export const timestampFromDate = (value) => {
  const date = value?.split('/') || undefined
  if (date?.length !== 3) return undefined
  if (date[2].length !== 4) return undefined
  return `${date[2]}-${date[1]}-${date[0]}`
}

export const dateFromString = (value) => {
  const date = value?.slice(0, 10).split('-') || ['01', '01', '2000']
  return `${date[2]}/${date[1]}/${date[0]}`
}

export const dateInFull = (value) => {
  if (value === null || value === undefined) {
    return '-'
  } else {
    return moment(value).format('LL')
  }
}

export const parseDateCalendar = (value) => {
  const isValidDate = isValid(value)

  if (isValidDate) {
    return format(value, "yyyy-MM-dd'T'HH:mm:ss")
  }
}
